export const appRegexConstants = {
  canadianPostalCodeRegex:
    /^[ABCEGHJKLMNPRSTVWXYZ][0-9][ABCEGHJKLMNPRSTVWXYZ][ ]?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9]$/i,
  usaPostalCodeRegex: /^\d{5}(-\d{4})?$/,
}
